module.exports = __webpack_public_path__ + "img/Logotype_Light.2be736b1.png";